import React from "react";
import { useParams } from "react-router-dom";
import { RefActivity } from "../../../../api/hooks";
import ActivityView from "../../../../common/activity/ActivityView";

const EquipmentStockRequestActivity = () => {
    const { stockRequestId } = useParams<any>();
    return (
        <div>
            {stockRequestId && (
                <ActivityView
                    className="mt-3 border"
                    activityRef={RefActivity?.EquipmentRequest}
                    activityRefId={stockRequestId ?? ""}
                />
            )}
        </div>
    );
};

export default EquipmentStockRequestActivity;
